var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.75C6 3.7835 6.7835 3 7.75 3H7.76C8.7265 3 9.51 3.7835 9.51 4.75C9.51 5.7165 8.7265 6.5 7.76 6.5H7.75C6.7835 6.5 6 5.7165 6 4.75ZM6 9.75C6 8.7835 6.7835 8 7.75 8H7.76C8.7265 8 9.51 8.7835 9.51 9.75C9.51 10.7165 8.7265 11.5 7.76 11.5H7.75C6.7835 11.5 6 10.7165 6 9.75ZM6 14.75C6 13.7835 6.7835 13 7.75 13H7.76C8.7265 13 9.51 13.7835 9.51 14.75C9.51 15.7165 8.7265 16.5 7.76 16.5H7.75C6.7835 16.5 6 15.7165 6 14.75ZM11 4.75C11 3.7835 11.7835 3 12.75 3H12.76C13.7265 3 14.51 3.7835 14.51 4.75C14.51 5.7165 13.7265 6.5 12.76 6.5H12.75C11.7835 6.5 11 5.7165 11 4.75ZM11 9.75C11 8.7835 11.7835 8 12.75 8H12.76C13.7265 8 14.51 8.7835 14.51 9.75C14.51 10.7165 13.7265 11.5 12.76 11.5H12.75C11.7835 11.5 11 10.7165 11 9.75ZM11 14.75C11 13.7835 11.7835 13 12.75 13H12.76C13.7265 13 14.51 13.7835 14.51 14.75C14.51 15.7165 13.7265 16.5 12.76 16.5H12.75C11.7835 16.5 11 15.7165 11 14.75Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragNew);
export default __webpack_public_path__ + "static/media/drag-new.c07baa4ed5d8cc401ad2c66bcd406bb6.svg";
export { ForwardRef as ReactComponent };